import * as React from 'react';
import { useState, useEffect } from 'react';
import {ScrollView} from '../ScrollView/ScrollView';
import { Subject} from 'rxjs';
import { Database } from '../../Managers/DataManager';
import { takeUntil } from 'rxjs/operators';
import { motion } from 'framer-motion';
import "./ProgramShelf.css";
import { useHistory } from 'react-router';
import { Image, ImageAnimations } from '../Image/Image';


export const ProgramShelf = () => {
    const [programs, setPrograms] = useState([])
    const leaving = new Subject<void>()

    const history = useHistory()

    useEffect(() => {
        Database.get('/programs')
        .then(sub => {
            sub.pipe(takeUntil(leaving))
            .subscribe(setPrograms)
        })
        .catch(console.error)

        return () => leaving.next()
    }, [])


  
    const renderItem = (item: any) => {
        const onProgramSelected = () => {
            history.push(`/program/${item.id}`)
        } 
        return(
            <motion.a className="programs-container" onClick={onProgramSelected}>
                <Image
                    animation={ImageAnimations.scale}
                    key={`program-thumbnail-${item.name}`}
                    src={item.thumbnail} 
                    alt="program image" 
                    />
                <div className="programs-img-gradient"></div>
            </motion.a>
        )
    }

    return(
        <div className="programs-outer-container">
            <ScrollView             
                style={{backgroundColor: 'red'}}
                data={programs}
                title={"Programs"}
                renderItem={renderItem}
                keyExtractor={(item) => item.name}
            />
        </div>
    )
}